var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
    style: {
      fill: "#323E48"
    }
  }, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#323E48",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "store-shop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61,54H58V27.576A5,5,0,0,0,61,23V21h-.025a.989.989,0,0,0-.005-.243L58,8.876V5a1,1,0,0,0-1-1H7A1,1,0,0,0,6,5V8.876L3.03,20.757a.989.989,0,0,0,0,.243H3v2a5,5,0,0,0,3,4.576V54H3a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H61a1,1,0,0,0,1-1V55A1,1,0,0,0,61,54ZM56,26a3,3,0,0,1-3-3V22h6v1A3,3,0,0,1,56,26ZM19.913,10,19.08,20h-5.9l1.667-10Zm29.24,0L50.82,20h-5.9l-.833-10ZM42.08,10l.833,10H37V10ZM35,20H29V10h6Zm-8,0H21.087l.833-10H27ZM13,22h6v1a3,3,0,0,1-6,0Zm8,0h6v1a3,3,0,0,1-6,0Zm8,0h6v1a3,3,0,0,1-6,0Zm8,0h6v1a3,3,0,0,1-6,0Zm8,0h6v1a3,3,0,0,1-6,0Zm7.847-2L51.18,10h5.039l2.5,10ZM56,6V8H8V6ZM7.781,10H12.82L11.153,20H5.281ZM5,23V22h6v1a3,3,0,0,1-6,0Zm3,5a4.982,4.982,0,0,0,4-2.031,4.954,4.954,0,0,0,8,0,4.954,4.954,0,0,0,8,0,4.954,4.954,0,0,0,8,0,4.954,4.954,0,0,0,8,0,4.954,4.954,0,0,0,8,0A4.982,4.982,0,0,0,56,28V54H54V33a1,1,0,0,0-1-1H43a1,1,0,0,0-1,1V54H8ZM52,54H44V34h8Zm8,4H4V56H60Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,32H11a1,1,0,0,0-1,1V49a1,1,0,0,0,1,1H39a1,1,0,0,0,1-1V33A1,1,0,0,0,39,32ZM38,48H12V34H38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.172,
    y: 38,
    width: 5.657,
    height: 2,
    transform: "translate(-22.012 24.858) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.136,
    y: 39.5,
    width: 12.728,
    height: 2,
    transform: "translate(-21.755 28.479) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.172,
    y: 42,
    width: 5.657,
    height: 2,
    transform: "translate(-22.205 32.393) rotate(-45)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStore);
export default __webpack_public_path__ + "static/media/icon_store.c5010aef.svg";
export { ForwardRef as ReactComponent };